<div ng-if="editor.isDesigning()" ng-show="isDragged" class="shadow"></div>
<c-form-element-actions ng-if="editor.isDesigning()" editor="editor" element="field"></c-form-element-actions>
<label ng-class="{selectable:editor.isDesigning()}" ng-mousedown="editor.dragBegin(field, $event)" title="{{(editor.isDesigning() ? 'move':'')|translate}}" ng-bind-html="labelText"></label>
<span ng-if="!tool" ng-bind-html="descriptionText"></span>
<div class="search-result-list">
    <c-list config="listConfig" style="{{tool ? 'height: 30px;border: 1px solid lightgray;margin-top:5px' : 'height: 300px;'}}"></c-list>
</div>